export default () => {
  const tabs = document.querySelectorAll('[data-tabs]');

  const init = el => {
    const tabBtns = el.querySelectorAll('[data-tab-btn]')
    const tabsContents = el.querySelectorAll('[data-tab-content]')

    el.onclick = e => {
      const tabId = e.target.dataset.tabId;

      if(tabId){
        tabBtns.forEach(el => el.classList.remove('active'));
        tabsContents.forEach(el => el.classList.remove('active'));
        e.target.classList.add('active');
        el.querySelector(`[data-content-id="${tabId}"]`).classList.add('active')
      }
    }
  }

  tabs.forEach(el => init(el))
}